import {
  createContext,
  SetStateAction,
  useCallback,
  useContext,
  useState,
} from "react";
import { APP_MSG } from "../../constants/cts_contextErrors";
import { IAppContext } from "../../interfaces/appContext";

const AppContext = createContext(null);

export const AppProvider = (props: any) => {
  const [isLoading, _setIsLoading] = useState(false);
  const [language, _setLanguage] = useState<
    SetStateAction<undefined> | string
  >();
  const [y, setY] = useState(0);

  return (
    <AppContext.Provider
      {...props}
      value={{
        isLoading,
        language,
        y,
        // function
        setY,
      }}
    />
  );
};

export const useApp = (): IAppContext => {
  const context = useContext(AppContext);
  if (!context) throw new Error(APP_MSG);
  return context;
};
